export const NAVBAR_HEIGHT = 64;
export const FOOTER_HEIGHT = 56;
